import { useEffect, useMemo } from 'react';
import { getCriticalFailureReason } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { CriticalFailureReasons } from 'calling-cross-tab-library/constants/CriticalFailureReasons';
export const useShowCriticalErrorAlert = (openRemote, isHubSpotCallingEnabled, hasPortalFromNumbers) => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const criticalFailureReason = getCriticalFailureReason(widgetDetails) || CriticalFailureReasons.NONE;
  const showCriticalErrorAlert = useMemo(() => criticalFailureReason !== CriticalFailureReasons.NONE && criticalFailureReason !== CriticalFailureReasons.FETCH_TOKEN_ERROR && criticalFailureReason !== CriticalFailureReasons.MICROPHONE_PERMISSION_ERROR, [criticalFailureReason]);
  useEffect(() => {
    if (showCriticalErrorAlert && isHubSpotCallingEnabled && hasPortalFromNumbers) {
      openRemote();
    }
  }, [hasPortalFromNumbers, isHubSpotCallingEnabled, openRemote, showCriticalErrorAlert]);
  return {
    showCriticalErrorAlert
  };
};